export const ANALYTICS_EVENTS = {
  ACCOUNTS_CLICK_ACCOUNT: 'accounts_widget_click_account',
  ACCOUNTS_CLICK_CONNECT: 'accounts_widget_click_connect_accounts',
  ACCOUNTS_CLICK_FILTER: 'accounts_widget_click_filter_accounts',
  ACCOUNTS_CLICK_SYNC: 'accounts_widget_click_sync',
  ACCOUNT_DETAILS_CLICK_HIDE: 'account_details_click_hide_account',
  ACCOUNT_DETAILS_CLICK_MARK_CLOSED: 'account_details_click_mark_as_closed',
  ACCOUNT_DETAILS_CLICK_MARK_DUPLICATE: 'account_details_click_mark_as_duplicate',
  ACCOUNT_DETAILS_CLICK_TRANSACTION: 'account_details_click_transaction',
  ACCOUNT_DETAILS_VIEW: 'account_details',
  ACCOUNT_DETAILS_VIEW_TRANSACTIONS: 'account_details_transactions',
  BUDGETS_CLICK_ADD: 'budgets_widget_click_add_budget',
  BUDGETS_CLICK_BUDGET_CATEGORY: 'budgets_widget_click_budget_category',
  BUDGETS_CLICK_EDIT_INCOME: 'budgets_widget_click_edit_income',
  BUDGETS_CLICK_FILTER: 'budgets_widget_click_filter_accounts',
  BUDGETS_VIEW: 'budgets',
  CASH_FLOW_CLICK_FILTER: 'cash_flow_widget_click_filter_accounts',
  CASH_FLOW_CLICK_SETTINGS: 'cash_flow_widget_click_settings',
  DEBTS_CLICK_CHART_AREA: 'debts_widget_click_chart_area',
  DEBTS_CLICK_FILTER: 'debts_widget_click_filter_accounts',
  DEBTS_CLICK_PAYDOWN: 'debts_widget_click_paydown',
  DEBTS_CLICK_PRIORITY: 'debts_widget_click_priority',
  DEBTS_CLICK_PRIORITIZE: 'debts_widget_click_prioritize',
  DEBTS_CLICK_SNOWBALL_CTA: 'debts_widget_click_snowball_cta',
  DEBTS_CLICK_TABLE_ROW: 'debts_widget_click_table_row',
  DEBTS_CLICK_TABLE_SORT: 'debts_widget_click_table_sort',
  DEBTS_SAVE_BALANCE_ACTION: 'debts_widget_click_balance_action',
  DEBTS_SAVE_PAYDOWN_ACTION: 'debts_widget_click_paydown_action',
  DEBTS_SAVE_PAYMENT_ACTION: 'debts_widget_click_payment_action',
  DEBTS_SAVE_RATE_ACTION: 'debts_widget_click_rate_action',
  DEBTS_VIEW: 'debts',
  DEBT_DETAILS_VIEW: 'debt_details',
  DEBT_SCHEDULE_VIEW: 'debt_schedule',
  GOALS_CLICK_ADD: 'goals_widget_click_add',
  GOALS_CLICK_FILTER: 'goals_widget_click_filter_accounts',
  GOALS_VIEW: 'goals',
  GOALS_MICRO_WIDGET_CTA: 'goals_micro_widget_click_see_details_cta',
  HELP_CLICK_CATEGORY: 'help_click_category',
  HELP_CLICK_REQUEST_SUPPORT: 'help_click_requestSupport',
  HELP_CLICK_SUPPORT_FOR_INSTITUTION: 'help_click_supportForInstitution',
  HELP_CLICK_SUPPORT_FOR_MISSING_INSTITUTION: 'help_click_supportForMissingInstitution',
  HELP_CLICK_SUPPORT_TOPIC: 'help_click_supportTopic',
  HELP_CLICK_TOPIC: 'help_click_topic',
  HELP_EXPAND_CATEGORY: 'help_expand_category',
  HELP_EXPAND_TOPIC: 'help_expand_topic',
  HELP_OPEN_SUPPORT_REQUEST: 'help_open_supportRequest',
  HELP_SUBMIT_SUPPORT_REQUEST: 'help_submit_supportRequest',
  INVESTMENTS: 'Investments',
  INVESTMENT_WIDGET_ACCOUNT_FILTER_CLICK: 'investment_widget_account_filter_click',
  INVESTMENT_WIDGET_ALLOCATION_CLICK: 'investment_widget_allocation_click',
  INVESTMENT_WIDGET_ANALYSIS_CLICK: 'investment_widget_analysis_click',
  INVESTMENT_WIDGET_DETAILS_CLICK: 'investment_widget_details_click',
  NET_WORTH_VIEW: 'netWorth',
  NETWORTH_MICRO_WIDGET_CTA: 'net_worth_micro_widget_click_see_details_cta',
  NET_WORTH_WIDGET_CLICK_ASSETS_LIABILITIES: 'net_worth_widget_click_view_assets_liabilities',
  NET_WORTH_WIDGET_CLICK_FILTER: 'net_worth_widget_click_filter_accounts',
  NET_WORTH_WIDGET_CLICK_TIMEFRAME: 'netWorth_click_timePeriod',
  RECURRING_ACTIVITY_CLICK_ADD_EXPENSE:
    'recurring_transactions_widget_manage_expenses_click_add_expense',
  RECURRING_ACTIVITY_CLICK_ADD_INCOME:
    'recurring_transactions_widget_income_details_click_add_income',
  RECURRING_ACTIVITY_CLICK_CALENDAR_RIGHT: 'recurring_transactions_widget_click_calendar_right',
  RECURRING_ACTIVITY_CLICK_EXPENSE: 'recurring_transactions_widget_manage_expenses_click_expense',
  RECURRING_ACTIVITY_CLICK_FILTER: 'recurring_transactions_widget_click_filter_accounts',
  RECURRING_ACTIVITY_CLICK_INCOME: 'recurring_transactions_widget_click_income',
  RECURRING_ACTIVITY_CLICK_PAID: 'recurring_transactions_widget_click_paid_expense',
  RECURRING_ACTIVITY_CLICK_SETTINGS: 'recurring_transactions_widget_click_settings',
  RECURRING_ACTIVITY_CLICK_UPCOMING: 'recurring_transactions_widget_click_upcoming_transaction',
  RECURRING_TRANSACTIONS_CLICK_ADD_EXPENSE:
    'recurring_transactions_widget_manage_expenses_click_add_expense',
  RECURRING_TRANSACTIONS_CLICK_ADD_INCOME:
    'recurring_transactions_widget_income_details_click_add_income',
  RECURRING_TRANSACTIONS_CLICK_CALENDAR_RIGHT: 'recurring_transactions_widget_click_calendar_right',
  RECURRING_TRANSACTIONS_CLICK_EXPENSE:
    'recurring_transactions_widget_manage_expenses_click_expense',
  RECURRING_TRANSACTIONS_CLICK_FILTER: 'recurring_transactions_widget_click_filter_accounts',
  RECURRING_TRANSACTIONS_CLICK_INCOME: 'recurring_transactions_widget_click_income',
  RECURRING_TRANSACTIONS_CLICK_PAID: 'recurring_transactions_widget_click_paid_expense',
  RECURRING_TRANSACTIONS_CLICK_SETTINGS: 'recurring_transactions_widget_click_settings',
  RECURRING_TRANSACTIONS_CLICK_UPCOMING: 'recurring_transactions_widget_click_upcoming_transaction',
  RECURRING_TRANSACTIONS_DETAILS_CLICK_DELETE: 'recurring_transactions_widget_details_click_delete',
  RECURRING_TRANSACTIONS_DETAILS_CLICK_PAYMENT_SCHEDULE:
    'recurring_transactions_widget_details_click_payment_schedule',
  RECURRING_TRANSACTIONS_LIST_CLICK_MARK_AS_PAID:
    'recurring_transactions_widget_list_click_mark_as_paid',
  RECURRING_TRANSACTIONS_LIST_CLICK_MARK_AS_UNPAID:
    'recurring_transactions_widget_list_click_mark_as_unpaid',
  RECURRING_TRANSACTIONS_LIST_CLICK_MORE_MENU: 'recurring_transactions_widget_list_click_more_menu',
  RECURRING_TRANSACTIONS_MICRO_WIDGET_CTA: 'recurring_transactions_micro_widget_click_view_all_cta',
  SPENDING_CLICK_FILTER: 'spending_widget_click_filter_accounts',
  SPENDING_VIEW: 'spending',
  TRANSACTIONS_ADD_MANUAL_ACCOUNT_MODAL: 'transactions_add_manual_account_modal',
  TRANSACTIONS_CLICK_ADD: 'transactions_click_add_transaction',
  TRANSACTIONS_CLICK_DETAILS: 'transactions_click_transaction_details',
  TRANSACTIONS_CLICK_EXPORT: 'transactions_click_export_csv',
  TRANSACTIONS_CLICK_FILTER: 'transactions_click_filter_accounts',
  TRANSACTIONS_CLICK_SEARCH: 'transactions_click_search',
  TRANSACTIONS_VIEW: 'transactions',
  TRANSACTION_DETAILS_CLICK_AMOUNT: 'transaction_details_click_transaction_amount',
  TRANSACTION_DETAILS_CLICK_CATEGORY: 'transaction_details_click_category',
  TRANSACTION_DETAILS_CLICK_DATE: 'transaction_details_click_date',
  TRANSACTION_DETAILS_CLICK_DELETE_LOGO: 'transaction_details_click_delete_merchant_logo',
  TRANSACTION_DETAILS_CLICK_DESCRIPTION: 'transaction_details_click_edit_description',
  TRANSACTION_DETAILS_CLICK_FLAG: 'transaction_details_click_flag_transaction',
  TRANSACTION_DETAILS_CLICK_MEMO: 'transaction_details_click_memo',
  TRANSACTION_DETAILS_CLICK_SPLIT: 'transaction_details_click_split_transaction',
  TRANSACTION_DETAILS_CLICK_TAGS: 'transaction_details_click_tags',
  TRANSACTION_DETAILS_CLICK_UNSPLIT: 'transaction_details_click_unsplit_transaction',
  TRANSACTION_DETAILS_VIEW: 'transaction_details',
  TRANSACTIONS_TABLE_CLICK_CATEGORY: 'transactions_table_click_category',
  WIDGET_BACK_CLICK: 'widget_back_button_click',

  // NEW ANAYTICS EVENT FORMAT
  // widget_action_subject
  GOALS_CLICK_GET_STARTED: 'goals_click_getStarted',
  GOALS_CLICK_VIEW_DETAILS: 'goals_click_viewDetails',
  GOALS_LOAD_WIDGET: 'goals_load_widget',
  NET_WORTH_CLICK_GET_STARTED: 'netWorth_click_getStarted',
  NET_WORTH_CLICK_VIEW_DETAILS: 'netWorth_click_viewDetails',
  NET_WORTH_LOAD_WIDGET: 'netWorth_load_widget',
  RECURRING_TRANSACTIONS_CLICK_GET_STARTED: 'recurringTransactions_click_getStarted',
  RECURRING_TRANSACTIONS_CLICK_VIEW_ALL: 'recurringTransactions_click_viewAll',
  RECURRING_TRANSACTIONS_LOAD_WIDGET: 'recurringTransactions_load_widget',
  TRENDS_CLICK_ALL_CATEGORIES: 'trends_click_allCategories',
  TRENDS_CLICK_BACK: 'trends_click_back',
  TRENDS_CLICK_CHART: 'trends_click_chart',
  TRENDS_CLICK_CONNECT_ACCOUNTS: 'trends_click_connectAccounts',
  TRENDS_CLICK_EXPORT_CSV: 'trends_click_exportCSV',
  TRENDS_CLICK_FILTER: 'trends_click_filter',
  TRENDS_CLICK_GET_STARTED: 'trends_click_getStarted',
  TRENDS_CLICK_INSIGHT: 'trends_click_insight',
  TRENDS_CLICK_LEGEND: 'trends_click_legend',
  TRENDS_CLICK_LIST_ITEM: 'trends_click_listItem',
  TRENDS_CLICK_TABLE_SORT: 'trends_click_tableSort',
  TRENDS_CLICK_TIME_WINDOW: 'trends_click_timeWindow',
  TRENDS_CLICK_TOGGLE_VIEW: 'trends_click_toggleView',
  TRENDS_CLICK_VIEW_MORE: 'trends_click_viewMore',
  TRENDS_CLICK_VIEW_TRANSACTIONS: 'trends_click_viewTransactions',
  TRENDS_HOVER_AREA: 'trends_hover_chartArea',
  TRENDS_HOVER_POINT: 'trends_hover_chartPoint',
  TRENDS_HOVER_LEGEND: 'trends_hover_ChartLegend',
  TRENDS_LOAD_WIDGET: 'trends_load_widget',
  TRENDS_VIEW_TRANSACTIONS: 'trends_view_transactions',
  WIDGET_SIZE_CHANGED: 'widget_size_changed',
}
